/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect, useState } from 'react';
import { Dialog, MessageBar } from '@eta/components';
import { useTranslation } from 'react-i18next';
import { DefaultButton, MessageBarType, PrimaryButton } from 'office-ui-fabric-react';
import { ServiceCreator } from '../../../Services/ClientProxy/ServiceFactory';
import { Spacer } from '../../../common/component/Spacer';
import { CurrentDeviceStatusCommandDto, DeviceStatusDto } from '../../../Services/POS/PosService';
import { POSStatus } from '../../../common/config/constants';
import './StatusDialog.scss';

export interface Props {
    data?: any;
    multiple?: boolean;
    currentStatus?: boolean;
    onSave: () => void;
    onClose: () => void;
}

export const StatusDialog: FC<Props> = (props: Props) => {
    const { data, onSave, onClose,multiple } = props;
    const { t } = useTranslation(['pos']);
    const [loadingText] = useState<string>('');
    const [error, setError] = useState<string>();
    const [isActive, setIsActive] = useState<boolean>();
    const [itemName, setItemName] = useState<string>();

    useEffect(() => {
        if (!multiple) {
            const { name, status, statusId } = data;
            const st = status ? (status === 'Active' || status === 'Pending') : (statusId === POSStatus.Active || statusId === POSStatus.Pending);
            setItemName(name);
            setIsActive(multiple ? true : st);
        } else {
            const { status, statusId } = data[0];
            const st = status ? (status === 'Active' || status === 'Pending') : (statusId === POSStatus.Active || statusId === POSStatus.Pending);
            setItemName(`${data?.length} ${t('Devices')}`);
            setIsActive(st);
        }
    }, [data]);

    const ChangeStatus = async () => {
        try {
            const client = ServiceCreator.getPosManagementPublicClient();
            const list = [];
            if (multiple) {
                for (let i = 0; i < data?.length; i += 1) {
                    list.push(data[i].id);
                }
            } else {
                list.push(data.id);
            }
            const obj = new CurrentDeviceStatusCommandDto();
            obj.status = isActive
                ? DeviceStatusDto.InActive
                : DeviceStatusDto.Active;
            obj.devicesId = list;
            await client.editDevicesStatus(obj);
            onSave();
        } catch (ex) {
            const exp = ex as any;
            setError(exp?.response?.message.toString());
        }
    };

    return (
        <Dialog
            containerClassName='posStatus'
            hidden={false}
            onDismiss={() => { onClose(); }}
            loadingText={loadingText}
            maxWidth={450}
            title={(
                <div className={isActive ? 'statusDeactiveTitle' : 'statusReactiveTitle'}>
                    {`${t(isActive ? 'deactivateDevice' : 'reactivateDevice',{device:itemName})}`}
                </div>
            )}
            Footer={(
                <>
                    <Spacer direction='vertical' size={5} />
                    <DefaultButton
                        className={isActive ? 'active' : 'in-active'}
                        onClick={() => onClose()}
                        text={t(isActive ? 'keepActive' : 'keepInactive')}
                    />
                    <PrimaryButton
                        className={isActive ? 'deactivate' : 'reactivate'}
                        onClick={() => ChangeStatus()}
                        text={t(isActive ? 'confirmDectivate' : 'confirmReactivate')}
                    />
                </>
            )
            }
        >
            <div>
                <div className='MessageBar'>
                    {error && (
                        <>
                            <MessageBar
                                messageBarType={MessageBarType.blocked}
                                isMultiline={false}
                                onDismiss={() => setError('')}
                                truncated
                            >
                                {error}
                            </MessageBar>
                        </>
                    )}
                    {
                        !isActive ? (
                            <div>
                                <div className='statusMessage'>
                                    <span>{t(multiple ? 'reactivateMessage3' : 'reactivateMessage1')}</span>
                                    <span className='bold'>{t('reactivateMessage2')}</span>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div>
                                    <div className='statusMessage'>
                                        <span>{t(multiple ? 'deactivateDevMessage3' : 'deactivateDevMessage1')}</span>
                                        <span className='bold'>{t('deactivateDevMessage2')}</span>
                                    </div>
                                </div>
                                <Spacer direction='vertical' size={5} />
                               
                            </div>
                        )
                    }

                </div>
            </div>
        </Dialog>
    );
};
